import React from "react";
import TabComponent from "../Tabs";

const SectionTwo = (props) => {
  const { openMod } = props;
  return (
    <div>
      <TabComponent openMod={openMod} />
    </div>
  );
};

export default SectionTwo;
